import React from 'react';

const Section9_wf = ({ imgWebp, imgJpg, videoSrc, imgAlt, title, subtitle, desc }) => {
  return (
    <section className="section-9">

      <div className='container'>
        <div className='other-row content mb-5'>
            <div className='col col-100 text-center'>
                <picture>
                    <source type="image/webp" srcSet="/img/water-analytics-hero-section.webp" />
                    <img className='mb-2 hero mobile-d-block desktop-d-none' src="/img/water-analytics-hero-section.webp" alt="Responsive" />
                </picture>
                <h3 className='title'>Easy Maintenance</h3>
                <p className='desc mw-100'>To keep your Water Filter System running efficiently, it's recommended to follow the filter change schedule below.<br/> Regular maintenance ensures the system provides optimal water quality and prolongs the life of each filter stage.</p>
            </div>
        </div>
        <div className='other-row'>
            <div className='col col-50'>
                <div className='items'>
                    <div className='item col col-50'>
                        <picture>
                            <source type="image/webp" srcSet="/img/mdi_water-filter-black.webp" />
                            <img className='mb-2' src="/img/mdi_water-filter-black.webp" alt="Responsive" />
                        </picture>
                        <h4>Free Stage 1 filter</h4>
                        <p className='desc w-100 mw-100'>Every full home system gets a new stage 1 filter every 6 months.</p>
                    </div>
                    <div className='item col col-50'>
                        <picture>
                            <source type="image/webp" srcSet="/img/mdi_water-filter-black.webp" />
                            <img className='mb-2' src="/img/mdi_water-filter-black.webp" alt="Responsive" />
                        </picture>
                        <h4>Stage 2 filter</h4>
                        <p className='desc w-100 mw-100'>12 Months</p>
                    </div>
                </div>
                <div className='items'>
                    <div className='item col col-50'>
                        <picture>
                            <source type="image/webp" srcSet="/img/mdi_water-filter-black.webp" />
                            <img className='mb-2' src="/img/mdi_water-filter-black.webp" alt="Responsive" />
                        </picture>
                        <h4>Stage 3 filter</h4>
                        <p className='desc w-100 mw-100'>12 months</p>
                    </div>
                    <div className='item col col-50'>
                        <picture>
                            <source type="image/webp" srcSet="/img/mdi_water-filter-black.webp" />
                            <img className='mb-2' src="/img/mdi_water-filter-black.webp" alt="Responsive" />
                        </picture>
                        <h4>Stage 4 filter</h4>
                        <p className='desc w-100 mw-100'>24 months</p>
                    </div>
                </div>
                <div className='items'>
                    <div className='item col col-50'>
                        <picture>
                            <source type="image/webp" srcSet="/img/mdi_water-filter-black.webp" />
                            <img className='mb-2' src="/img/mdi_water-filter-black.webp" alt="Responsive" />
                        </picture>
                        <h4>Stage 5 filter</h4>
                        <p className='desc w-100 mw-100'>12 months</p>
                    </div>
                    <div className='item col col-50'>
                        <picture>
                            <source type="image/webp" srcSet="/img/mdi_water-filter-black.webp" />
                            <img className='mb-2' src="/img/mdi_water-filter-black.webp" alt="Responsive" />
                        </picture>
                        <h4>Stage 6 filter</h4>
                        <p className='desc w-100 mw-100'>12 months</p>
                    </div>
                </div>
                <h4 className='mb-3'>Schedule Filter <br/>Replacements</h4>
                <p className='desc w-100 mw-100'>To ensure you don't forget your filter change dates, you can book your maintenance appointments in advance.</p>
                <p className='desc w-100 mw-100'>Simply contact our support team or use our online scheduling tool to set reminders, and we'll send you a notification when it's time to replace each filter stage. This proactive approach helps maintain high water quality and keeps your system in top condition year-round.</p>
            </div>
            <div className='col col-50 mobile-d-none'>
                <picture>
                    <source type="image/webp" srcSet="/img/water-analytics-hero-section.webp" />
                    <img className='mb-2 hero' src="/img/water-analytics-hero-section.webp" alt="Responsive" />
                </picture>
            </div>
        </div>
      </div>

    </section>
  )
}

export default Section9_wf;